<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Plano Equipamento</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn
            v-if="equipamentoL.length > 0"
            class="ma-2 blue--text"
            @click="baixarLista"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-autocomplete
              v-model="planoSelected"
              :items="planosManutencao"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              v-on:change="changePlano()"
              :disabled="salvando"
              :rules="[(v) => !!v || 'Selecione o plano manutenção']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <sticky-add-button
        tooltip="Adicionar Equipamento"
        :disabled="!planoSelected || salvando || loading"
        @click="abrirModalEquipamento"
      />

      <v-form ref="formServ" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :loading="loading"
            loading-text="Buscando dados..."
            :search="search"
            :items-per-page="-1"
            hide-default-footer
            :items="equipamentoL"
          >
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeEquipamento(item.index)"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ equipamentoL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn
                v-model="fab"
                color="blue darken-2"
                dark
                fab
                :disabled="salvando"
              >
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="enviar"
              color="success"
              class="mr-4"
              :disabled="
                !planoSelected || salvando || loading || !possuiAlteracoes
              "
              :loading="salvando"
            >
              {{ salvando ? "Salvando..." : "Salvar" }}
            </v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      v-model="showModalEquipamento"
      :max-width="$vuetify.breakpoint.smAndDown ? '95vw' : '720px'"
      scrollable
      eager
    >
      <v-card class="rounded-xl">
        <v-card-title class="headline">
          Adicionar Equipamento
          <v-spacer />
        </v-card-title>

        <v-card-text class="pt-0">
          <equipamento
            ref="equipamentoAdd"
            :equipamentoL="equipamentoL"
          />
        </v-card-text>

        <v-card-actions
          class="px-4"
          style="
            position: sticky;
            bottom: 0;
            background: white;
            z-index: 1;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
          "
        >
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2"
            @click="showModalEquipamento = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { atualizarPlanoManutencaoEquipamentoAsync } from "../../../services/planoManutencaoService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";
import Equipamento from "./Equipamento.vue";
import StickyAddButton from "../../Shared/StickyAddButton.vue";
import { getUserRoles } from "@/services/loginService";
import { saveAs } from "file-saver";

export default {
  name: "criarPlanoEquipamento",
  data: () => ({
    search: "",
    loading: false,
    overlay: false,
    salvando: false,
    valid: true,
    descricao: null,
    itemTroca: false,
    planoSelected: null,
    equipamentoL: [],
    idsEquipamentosSalvos: [],
    requisicaoPlanoAtual: 0,
    showModalEquipamento: false,
    active_tab: 4,
    headers: [
      { text: "Item", value: "index", sortable: false },
      {
        text: "Id",
        align: "start",
        value: "idEquipamento",
      },
      { text: "Equipamento", value: "centroCusto" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    filters: {
      descricao: [],
    },
  }),
  computed: {
    ...mapState("planoManutencao", ["planosManutencao"]),
    ...mapState("equipamento", ["equipamentosPlano"]),
    possuiAlteracoes() {
      const atuais = this.equipamentoL
        .map((item) => item.idEquipamento)
        .filter(Boolean)
        .sort((a, b) => a - b);
      const salvos = [...this.idsEquipamentosSalvos].sort((a, b) => a - b);

      return JSON.stringify(atuais) !== JSON.stringify(salvos);
    },
  },
  methods: {
    ...mapActions("equipamento", ["atualizarPlanoEquipamentos"]),
    ...mapActions("planoManutencao", ["atualizarPlanosManutencao"]),
    async enviar() {
      if (
        this.salvando ||
        !this.possuiAlteracoes ||
        !this.$refs.form.validate()
      ) {
        return;
      }

      this.salvando = true;
      this.overlay = true;
      try {
        const resposta = await atualizarPlanoManutencaoEquipamentoAsync(
          this.planoSelected.id,
          this.equipamentoL
        );

        if (resposta?.status !== 200) {
          throw new Error(
            resposta?.message || "Não foi possível salvar os vínculos."
          );
        }

        this.idsEquipamentosSalvos = this.equipamentoL.map(
          (item) => item.idEquipamento
        );
        this.$store.dispatch("ui/showSnackbar", {
          text:
            resposta.data?.mensagem ||
            resposta.data?.Mensagem ||
            "Vínculos salvos com sucesso!",
          color: "success",
          timeout: 3000,
        });
      } catch (erro) {
        this.$alert(
          erro?.message ||
            "Não foi possível salvar os vínculos. Tente novamente.",
          "Falha ao salvar",
          "error"
        );
      } finally {
        this.salvando = false;
        this.overlay = false;
      }
    },
    async changePlano() {
      if (this.planoSelected != null) {
        const idPlano = this.planoSelected.id;
        const requisicao = ++this.requisicaoPlanoAtual;
        this.loading = true;
        try {
          await this.atualizarPlanoEquipamentos(idPlano);

          if (
            this.planoSelected?.id !== idPlano ||
            requisicao !== this.requisicaoPlanoAtual
          ) {
            return;
          }

          const equipamentosUnicos = Array.from(
            new Map(
              this.equipamentosPlano.map((item) => [item.id, item])
            ).values()
          );
          this.equipamentoL = JSON.parse(JSON.stringify(equipamentosUnicos));
          this.equipamentoL.forEach((e, index) => {
            e.idEquipamento = e.id;
            e.index = index;
          });
          this.idsEquipamentosSalvos = this.equipamentoL.map(
            (item) => item.idEquipamento
          );
        } catch (erro) {
          if (requisicao !== this.requisicaoPlanoAtual) {
            return;
          }
          this.equipamentoL = [];
          this.idsEquipamentosSalvos = [];
          this.$alert(
            "Não foi possível carregar os equipamentos vinculados.",
            "Falha ao carregar",
            "error"
          );
        } finally {
          if (requisicao === this.requisicaoPlanoAtual) {
            this.loading = false;
          }
        }
      }
    },

    async abrirModalEquipamento() {
      if (this.salvando || this.loading) {
        return;
      }

      await this.$refs.equipamentoAdd.carregarAoAbrir();
      this.showModalEquipamento = true;
    },
    removeEquipamento(index) {
      if (this.salvando) {
        return;
      }
      this.equipamentoL = this.equipamentoL.filter((e) => e.index != index);
    },
    baixarLista() {
      const blob = this.gerarExcel();
      saveAs(
        blob,
        `${this.nomeArquivoExcel(this.planoSelected?.descricao)}.xlsx`
      );
    },
    nomeArquivoExcel(descricao) {
      const nome = String(descricao || "")
        .trim()
        .replace(/[<>:"/\\|?*]/g, "_")
        .replace(/[. ]+$/g, "");
      return nome || "plano_manutencao";
    },
    gerarExcel() {
      const colunas = [
        { chave: "item", cabecalho: "Item" },
        { chave: "idEquipamento", cabecalho: "Id" },
        { chave: "centroCusto", cabecalho: "Equipamento" },
      ];
      const linhas = this.equipamentoL.map((equipamento, index) => ({
        item: index + 1,
        idEquipamento: equipamento.idEquipamento || "",
        centroCusto: equipamento.centroCusto || "",
      }));
      const aoa = [
        colunas.map((coluna) => coluna.cabecalho),
        ...linhas.map((linha) => colunas.map((coluna) => linha[coluna.chave])),
      ];
      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      ws["!cols"] = colunas.map((coluna) => {
        const valores = [
          coluna.cabecalho,
          ...linhas.map((linha) => String(linha[coluna.chave] ?? "")),
        ];
        return {
          wch: Math.max(...valores.map((valor) => valor.length)) + 2,
        };
      });

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((coluna, index) => {
        const cell = ws[`${String.fromCharCode(65 + index)}1`];
        if (cell) cell.s = headerStyle;
      });

      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");
      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
    doAjax() {
      if (!this.planosManutencao || this.planosManutencao.length == 0) {
        this.atualizarPlanosManutencao();
      }
    },
  },
  created: function () {
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacao,
    Equipamento,
    StickyAddButton,
  },
};
</script>
